// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1PljK","list":"PatternAutocomplete_list__1rEjm"};